import Loader from "./loader";
import Autocompleter from "./autocompleter";
import Map from "./map";

export default class GoogleSource
{
	#code = 'GOOGLE';
	#languageId = '';
	#autocompleter = null;
	#loaderPromise = null;
	
	constructor(props)
	{
		this.#languageId = props.languageId;
		this.#loaderPromise = Loader.load(props.apiKey, props.languageId);
	}

	get autocompleter(): Autocompleter
	{
		if(this.#autocompleter === null)
		{
			this.#autocompleter = this.#createAutocompleter(this.#languageId);
		}

		return this.#autocompleter;
	}

	get sourceCode(): string
	{
		return this.#code;
	}

	#createAutocompleter(languageId: string)
	{
		return new Autocompleter({
			source: this,
			languageId: languageId,
			loaderPromise: this.#loaderPromise
		});
	}

	/**
	 *
	 * @param {Element} mapContainer
	 * @param {Location} location
	 * @param mode
	 * @param zoom
	 * @return {MapBase}
	 * todo: initial zoom
	 */
	createMap(mapContainer: Element, location: Location, mode, zoom: number): Map
	{
		return new Map({
			googleSource: this,
			languageId: this.#languageId,
			loaderPromise: this.#loaderPromise,
			mapContainer: mapContainer,
			location: location,
			mode: mode,
			zoom: zoom
		});
	}
}